import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
/* global document, module */
const container = document.getElementById("root");
if (!container) {
    throw new Error("Suade web workspace: could not find #root element to mount into.");
}
const root = createRoot(container);
root.render(_jsx(App, {}));
// Hot module replacement for local dev only — no effect in production build.
if (module.hot) {
    module.hot.accept();
}
